import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { DiHolaTrackingComponent } from './app/app.component';

bootstrapApplication(DiHolaTrackingComponent, appConfig)
  .catch((err) => console.error(err));